import React from "react";
import Editor from "@monaco-editor/react";

const JsonEditorPanel = ({ title, language, code, setCode, readOnly = false }) => {
  return (
    <div className="editor-section">
      <h3>{title}</h3>
      <Editor
        height="600px"
        defaultLanguage={language}
        value={code}
        onChange={(value) => setCode && setCode(value || "")}
        theme="vs-dark"
        options={{
          readOnly,             // disables editing
          domReadOnly: false,   // ✅ still allows mouse selection + Ctrl+C
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
        }}
      />
    </div>
  );
};

export default JsonEditorPanel;
